import { apiPut } from '@/store/api';

export interface IProspectEmailParam {
    guid: string;
    location: string;
    foreignKey: number;
    appStatus: string;
    templateId: number;
    isEmail: number;
}

export async function generateProspectEmail(param: IProspectEmailParam): Promise<boolean> {
    if (param && param.guid && param.location && param.foreignKey && param.appStatus && param.templateId) {
        const result = await apiPut('document/generate/', param)
        if (result.resultCategory === 0 && result.resultType === 0) {
            return true;
        }
    }
    return false;
}
